import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl'

import { CPM_EXPLAINED } from '@constants'
import { MediaTypes, SocialSubmissionTypes, SubmissionChannels } from '@enums'
import Theme from '@theme'
import { Link } from '@tribegroup'

type GlossaryDefinitionProps = {
  metric: string
  submissionType: SocialSubmissionTypes
  currency: string
  channel?: SubmissionChannels
  mediaType?: MediaTypes
  source?: string | null
} & WrappedComponentProps

const GlossaryDefinition: React.FC<GlossaryDefinitionProps> = ({
  intl,
  metric,
  currency,
  submissionType,
  channel,
  mediaType,
  source,
}) => {
  const ids = [
    source
      ? `analytics.breakdown.metric.${metric}.glossary.${submissionType}.${source}`
      : undefined,
    `analytics.breakdown.metric.${metric}.glossary.${submissionType}.${channel}.${currency}`,
    `analytics.breakdown.metric.${metric}.glossary.${submissionType}.${channel}.${mediaType}`,
    `analytics.breakdown.metric.${metric}.glossary.${submissionType}.${channel}`,
    `analytics.breakdown.metric.${metric}.glossary.${submissionType}`,
    `analytics.breakdown.metric.${metric}.glossary`,
  ].filter((id): id is string => Boolean(id))

  const messageId = ids.find((id) => {
    if (!id) return false
    const translationExist =
      intl.formatMessage({
        id,
      }) !== id
    return translationExist
  })

  return (
    <FormattedMessage
      id={messageId ?? `core.text.notapplicable`}
      values={{
        link: (
          <Link href={CPM_EXPLAINED} target="_blank" color={Theme.primaryColor} lowercase>
            <FormattedMessage id="core.text.clickHere" />
          </Link>
        ),
        taxDisplay: <FormattedMessage id={`core.currency.taxDisplay.${currency ?? 'generic'}`} />,
        currencySymbol: <FormattedMessage id={`core.currency.symbol.${currency ?? 'generic'}`} />,
      }}
    />
  )
}

export default injectIntl(GlossaryDefinition)
